import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import React, { Suspense } from 'react';

import { useAssetDataConfig } from './AssetListingDataGrid.config';

const AssetListingDataGrid = () => {
  const { config, data, loading } = useAssetDataConfig();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default AssetListingDataGrid;
